import { render, staticRenderFns } from "./PreProjectsSearchBar.vue?vue&type=template&id=309cac6b"
import script from "./PreProjectsSearchBar.vue?vue&type=script&lang=js"
export * from "./PreProjectsSearchBar.vue?vue&type=script&lang=js"
import style0 from "./PreProjectsSearchBar.vue?vue&type=style&index=0&id=309cac6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports